import { apiGet } from './default'
const fun_response = "/response_handlers/fundamentals_test/index.php?";
const fun_response2 = "/response_handlers/fundamentals2/";
const fun_response3 = "/response_handlers/fundamentals_search/index.php?";
const validation = "/portal.proxy/v1/portal";

/* We return a 200 code with an "error" field for *most* failures */
function handleError(call) {
    return new Promise((resolve, reject) => {
        call.then(response => {
            if (response.error) {
                reject(response.msg);
            } else {
                resolve(response);
            }
        })
    });
}

function getMarketCapParams(marketCaps) {
    if (!marketCaps) {
        return '&megacap=true&largecap=true&midcap=true&smallcap=true&microcap=true';
    }

    if (marketCaps.includes("All")) {
        return `&megacap=true&largecap=true&midcap=true&smallcap=true&microcap=true`;
    }
    
    let params = '';

    if (marketCaps.includes("mega_cap")) {
        params += `&megacap=true`;
    }
    if (marketCaps.includes("large_cap")) {
        params += `&largecap=true`;
    }
    if (marketCaps.includes("mid_cap")) {
        params += `&midcap=true`;
    }
    if (marketCaps.includes("small_cap")) {
        params += `&smallcap=true`;
    }
    if (marketCaps.includes("micro_cap")) {
        params += `&microcap=true`;
    }
    return params;
}

function checkCP(response) {
    return apiGet(`${validation}/sso/validate`);
}

function checkService(response) {
    return apiGet(`/response_handlers/fundamentals_test/index.php?`)
}

/**
 * Returns a list of filtered stocks, etfs & data based on input.
 * @param {string} symbol String that can be a ticker, company name, or etf name.
 * @param {Object} options Variables used for pagination
 */
function getCompanies(symbol, options, asset) {
    if (asset === 'etfs') asset = 'ETF';
    if (asset === 'all') asset = 'All'; 
    let query = "";
    let result = symbol.includes("'");
    if (result) {
        const sym = symbol.replace(/'/g, "\\'");
        query += `sym=${ sym }`;
    } else {
        query += `sym=${ symbol }`;
    }
    if (asset) {
        query += `&asset=${ asset }`;
    }
    if (options.limit) {
        query += `&size=${ options.limit }`;
    }
    if (options.page) {
        query += `&page=${ options.page }`;
    }
    if (asset === 'ETF' || asset === 'All') {
        return handleError(apiGet(`${ fun_response3 }${ query }`));
    } else {
        return handleError(apiGet(`${ fun_response }${ query }`));
    }
}

/**
 * Returns list of most recent FOREX quotes for input currency.
 * @param {string[]} oldcurr currencies (Shorthand) to convert from.
 * @param {string} newcurr desired currency to convert to.
 */
function getExchRate(oldcurr,newcurr) {
    return apiGet(`${ fun_response2 }currency.php?oldcurr=${oldcurr}&newcurr=${newcurr}`);
}

/**
 * Returns a list of filtered stocks & stock data based on the company's id from FUNDAMENTALS_REUTERS
 * @param {Object} data list of comma delimited tickers, desired currency, and desired ordering
 */
function searchByCompanyIds(data) {
    let query = ``;
    if (data.ids) { query += `ids=${ data.ids }`}
    // query += '&ticker=y';
    query += `&curr=${data.curr}&sort=${data.type},${data.dir}`;
    return handleError(apiGet(`${ fun_response }${ query }`));
}

/**
 * Returns a list of filtered ETF data based on the ETF's id from FUNDAMENTALS_ETFS
 * @param {Object} data list of comma delimited tickers, desired currency, and desired ordering
 */
 function searchByETFIds(data) {
    let query = ``;
    if (data.ids) { query += `ids=${ data.ids }`}
    // query += '&ticker=y';
    query += `&curr=${data.curr}&sort=${data.type},${data.dir}`;
    query += `&asset=${data.asset}`;
    return handleError(apiGet(`${ fun_response }${ query }`));
}

/**
 * Returns a list of stocks & data based on filter parameters
 * @param {Object} data filters for industries, countries, market capitalization, and desired currency
 */
function searchByInd(data) {
    let query = ``;
    if (data.industries) { query += `ind=${ data.industries }`}
    if (data.countries) { query += `&cnty=${ data.countries }`}
    query += getMarketCapParams(data.marketcap);
    query += `&curr=${data.currency}&page=${ data.page }&sort=${data.type},${data.dir}`;
    return handleError(apiGet(`${ fun_response }${ query }`));
}

/**
 * Get the weights sums for each column value
 * @param {Object} data filters for industries, countries, market capitalization, and desired currency
 */
function getWeightedSums(data, asset) {
    if(typeof data.industries === 'undefined' && typeof data.countries === 'undefined'){
        let query = ``;
        if(data.hasOwnProperty('stockIds') && data.hasOwnProperty('etfIds')){
            query += `stockIds=${ data.stockIds }`;
            query += `&etfIds=${ data.etfIds }`;
        } else {
            query += `ids=${data.ids}`
        }
        query += `&megacap=true&largecap=true&midcap=true&smallcap=true&microcap=true`;
        query += `&curr=${data.currency}&asset=${asset}&getAll=true`;
        return handleError(apiGet(`${ fun_response }${ query }`));
    } else {
        let query = ``;
        if (data.industries) { query += `ind=${ data.industries }`}
        if (data.countries) { query += `&cnty=${ data.countries }`}
        if (asset === 'ETF') {
            query += `&megacap=true&largecap=true&midcap=true&smallcap=true&microcap=true`;
        } else {
            query += getMarketCapParams(data.marketcap);
        }
        query += `&curr=${data.currency}&asset=${asset}&getAll=true`;

        return handleError(apiGet(`${ fun_response }${ query }`));
    }
}

function getSearchTerm(filters, ids, asset, currency, searchTerm) {
    if (asset === 'etfs') asset = 'ETF';
    let query = ``;
    if (filters.industries) { query += `ind=${ filters.industries }`}
    if (filters.countries) { query += `&cnty=${ filters.countries }`}
    if (asset === 'ETF') {
        query += getMarketCapParams();
    } else {
        query += getMarketCapParams(filters.marketcap);
    }
    if (asset === 'all') asset = 'All';
    query += `&asset=${asset}`;
    query += `&curr=${currency}`;
    query += `&page=${filters.page}&ids=${ids}&searchTerm=${searchTerm}`;
    return handleError(apiGet(`${ fun_response3 }${ query }`));
}

function searchETFs({industries, countries, currency, page, type, dir}) {
    let query = '';
    query += `ind=${ industries }`;
    query += `&cnty=${ countries }`;
    query += `&megacap=true&largecap=true&midcap=true&smallcap=true&microcap=true`;
    query+= `&curr=${currency}&page=${ page }&sort=${type},${dir}`;
    query+= '&asset=ETF';
    return handleError(apiGet(`${ fun_response }${ query }`));
}

function searchAll({industries, countries, marketcap, currency, page, type, dir}) {
    let query = '';
    query += `ind=${ industries }`;
    query += `&cnty=${ countries }`;
    query += '&asset=all';
    query += getMarketCapParams(marketcap);
    query += `&curr=${currency}&page=${page}&sort=${type},${dir}`;
    return handleError(apiGet(`${fun_response}${query}`));
}

function searchStockETFS({stockIds, etfIds, marketcap, currency, page, type, dir}) {
    let query = '';
    query += `stockIds=${ stockIds }`;
    query += `&etfIds=${ etfIds }`;
    query += `&megacap=true&largecap=true&midcap=true&smallcap=true&microcap=true`;
    query += '&asset=all';
    query += `&curr=${currency}&page=${page}&sort=${type},${dir}`;
    return handleError(apiGet(`${fun_response}${query}`));
}

function getLoginURL() {
    const url="https://www.interactivebrokers.com/response_handlers/ibam/index.php";
    return handleError(apiGet(url));
}

const getSummary = function(conid) {
    // const url="https://ci.interactivebrokers.scom/portal.proxy/ci/portal/iserver/fundamentals/" + conid + "/summary";
    const url="https://ndcdyn.interactivebrokers.com/portal.proxy/v1/mkt/iserver/fundamentals/" + conid + "/summary";
    return handleError(apiGet(url));
}

const getSecdefData = function(conid) {
    const url="https://ndcdyn.interactivebrokers.com/portal.proxy/v1/mkt/trsrv/secdef?conids=" + conid;
    return handleError(apiGet(url));
}

export default {
    checkCP,
    checkService,
    getCompanies,
    getExchRate,
    searchByCompanyIds,
    searchByETFIds,
    searchByInd,
    getWeightedSums,
    searchAll,
    searchStockETFS,
    getSearchTerm,
    searchETFs,
    getLoginURL,
    getSummary,
    getSecdefData
}
